import { isNil } from 'lodash-es';
import { gameRoundStatuses } from '../utils/racing-game/consts.ts';
import { useGameRoundData } from './useGameRoundData.ts';

export const useRoundInBreak = () => {
  const { data: roundData } = useGameRoundData();
  return !isNil(roundData)
    ? roundData.status === gameRoundStatuses.BREAK_PERIOD
    : undefined;
};
